/** Presentation adapters only; authorization and session ownership stay upstream. */
export function resolveCrmShell(basename: string, pathname: string, summer = false) {
  // Isolated summer sessions and live classrooms keep their existing shells until
  // their session-specific tools can be verified without the CRM staff context.
  if (import.meta.env.VITE_CRM_SHELL_ROLLOUT === 'false' || summer
    || /\/instructor\/groups\/[^/]+\/live$/.test(pathname)) return null;
  if ((basename === '/app' || basename === '/') && /^\/marketing\/work(?:\/|$)/.test(pathname)) {
    return { section: 'marketing', homePath: '/marketing/work' };
  }
  const section = basename === '/app' || basename === '/'
    ? pathname.split('/').filter(Boolean)[0] : basename.slice(1);
  const adapters: Record<string, string> = { manager: '/', reception: '/students', sales: '/', hr: '/', accountant: '/dashboard', marketing: '/dashboard', developer: '/developer/cockpit', instructor: '/instructor', employee: '/employee/profile', settings: '/employee/profile', mail: '/employee/mail' };
  if (!(section in adapters)) return null;
  const homePath = (basename === '/app' || basename === '/') && !['employee','instructor','developer','settings','mail'].includes(section) ? `/${section}${adapters[section]}` : adapters[section];
  return { section, homePath };
}
